var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 'width': _vm.width })},[_c('a-select',{staticClass:"ts-w-full",attrs:{"showSearch":"","mode":"multiple","placeholder":_vm.isPlaceholder ? _vm.placeholder : '',"optionFilterProp":"children","loading":_vm.loading,"maxTagTextLength":17,"maxTagCount":1,"options":_vm.options.map(function (el) { return ({
          value: el.branch_id,
          id: el.branch_id,
          label: el.branch_name_en
        }); }),"filterOption":function (input, option) { return option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0; }},on:{"change":_vm.changeValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }